import axios from 'axios'
import { EmployeeAcceptedPolicy } from './../../../types/EmployeeHandbook/employeeHandbookTypes'
import { AllowedHttpMethods, employeeHandbook } from '../apiList'
import { getAuthenticatedRequestConfig } from '../../../utils/apiUtils'
import {
  AddPolicyPayload,
  EmployeePolicyAgreementType,
  Handbook,
} from '../../../types/EmployeeHandbook/employeeHandbookTypes'

const getHandbooks = async (): Promise<Handbook[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeHandbook.getHandbooks,
    method: AllowedHttpMethods.get,
  })

  const response = await axios(requestConfig)
  return response.data
}

const getPublishedPolicy = async (): Promise<Handbook[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeHandbook.getPublishedPolicy,
    method: AllowedHttpMethods.get,
  })

  const response = await axios(requestConfig)
  return response.data
}

const getLoggedinEmployeeHandbookData = async (): Promise<
  EmployeePolicyAgreementType[]
> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeHandbook.getLoggedinEmployeeHandbookData,
    method: AllowedHttpMethods.get,
  })

  const response = await axios(requestConfig)
  return response.data
}

const addPolicyStatus = async (obj: AddPolicyPayload): Promise<void> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeHandbook.addPolicyStatus,
    method: AllowedHttpMethods.post,
    data: obj,
  })

  const response = await axios(requestConfig)
  return response.data
}

const getEmployeeAcceptedPolicy = async (): Promise<
  EmployeeAcceptedPolicy[]
> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeHandbook.getEmployeeAcceptedPolicies,
    method: AllowedHttpMethods.get,
  })

  const response = await axios(requestConfig)
  return response.data
}
const savePolicy = async (obj: EmployeeAcceptedPolicy): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeHandbook.saveEmployeePolicy,
    method: AllowedHttpMethods.post,
    params: {
      id: obj.id,
      handbookId: obj.handbookId,
      displayOrder: obj.displayOrder,
      pageName: obj.pageName,
      title: obj.title,
      employeeId: obj.employeeId,
      isAccepted: obj.isAccepted,
      acceptedDate: obj.acceptedDate,
      empName: obj.empName as string,
    },
  })

  const response = await axios(requestConfig)
  return response.data
}

const employeeHandbookApi = {
  getHandbooks,
  getPublishedPolicy,
  getLoggedinEmployeeHandbookData,
  addPolicyStatus,
  getEmployeeAcceptedPolicy,
  savePolicy,
}

export default employeeHandbookApi
